"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.impactBulkHardDeleteApi = impactBulkHardDeleteApi;
exports.impactBulkRestoreApi = impactBulkRestoreApi;
exports.impactBulkSoftDeleteApi = impactBulkSoftDeleteApi;
exports.impactCreateApi = impactCreateApi;
exports.impactCriteriaListApi = impactCriteriaListApi;
exports.impactDeleteAllApi = impactDeleteAllApi;
exports.impactDeleteApi = impactDeleteApi;
exports.impactListApi = impactListApi;
exports.impactListByIdYearApi = impactListByIdYearApi;
exports.impactListRestoreSoftDeleteApi = impactListRestoreSoftDeleteApi;
exports.impactPanelSequenceApi = impactPanelSequenceApi;
exports.impactRestoreSoftDeleteApi = impactRestoreSoftDeleteApi;
exports.impactSoftDeleteApi = impactSoftDeleteApi;
exports.impactTypeListApi = impactTypeListApi;
exports.impactUpdateApi = impactUpdateApi;
exports.reportImpactCheckUniqueApi = reportImpactCheckUniqueApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * search impact list with id and year
 * @param payload
 * @returns api response
 * @description this function used to search impact with id and year.
 */
function impactListByIdYearApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.impact), params);
}

/**
 * impact list with params
 * @param payload
 * @returns api response
 * @description this function used to impact list with params.
 */
function impactListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.list), params);
}

/**
 * impact criteriaList
 * @param payload
 * @returns api response
 * @description this function used to get criteria list.
 */
function impactCriteriaListApi() {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.list));
}

/**
 * impact create
 * @param payload
 * @returns api response
 * @description this function used to impact create given inputs.
 */
function impactCreateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.impact), params);
}

/**
 * impact update
 * @param payload
 * @returns api response
 * @description this function used to update impact given inputs.
 */
function impactUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.impact), params);
}

/**
 * impact delete
 * @param payload
 * @returns api response
 * @description this function used to delete impact of given params.
 */
function impactDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.impact), params);
}

/**
 * type list
 * @param payload
 * @returns api response
 * @description this function used to get type list.
 */
function impactTypeListApi() {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.typeList));
}

/**
 * impact delete
 * @param payload
 * @returns api response
 * @description this function used to delete impact of given params.
 */
function impactDeleteAllApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.deleteAll), params);
}

/**
 * impact update sequence
 * @param payload
 * @returns api response
 * @description this function used to update sequence.
 */
function impactPanelSequenceApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.sequence), params);
}
function impactSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.softDelete), params);
}
function impactRestoreSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.softDeleteRestore), params);
}
function impactListRestoreSoftDeleteApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.softDeleteList), params);
}
function impactBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.bulkSoftDelete), params);
}
function impactBulkHardDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.bulkHardDelete), params);
}
function impactBulkRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.bulkRestore), params);
}

/**
 * Check report impact is unique or not
 * @param payload
 * @returns api response
 * @description this function used to check report impact is unique.
 */
function reportImpactCheckUniqueApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.impact.uniqueReferenceNo), params);
}